import React from 'react';
import { AlertTriangle, TrendingDown, Package } from 'lucide-react';
import { cn, getSeverityColor } from '../lib/utils';

const AlertCard = ({ alert }) => {
  const getIcon = (type) => {
    switch (type) {
      case 'LOW_STOCK':
        return Package;
      case 'HIGH_VARIANCE':
        return TrendingDown;
      default:
        return AlertTriangle;
    }
  };

  const Icon = getIcon(alert.alert_type);

  return (
    <div
      className={cn(
        "p-4 rounded-lg border flex items-start gap-3",
        getSeverityColor(alert.severity)
      )}
      data-testid="alert-card"
    >
      <Icon className="w-5 h-5 mt-0.5 flex-shrink-0" />
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold" data-testid="alert-message">{alert.message}</p>
        {alert.ingredient_name && (
          <p className="text-xs mt-1 opacity-80" data-testid="alert-ingredient">{alert.ingredient_name}</p>
        )}
      </div>
      <span className={cn(
        "text-xs px-2 py-1 rounded-full border font-medium",
        getSeverityColor(alert.severity)
      )}>
        {alert.severity}
      </span>
    </div>
  );
};

export default AlertCard;
